import {
    BAD_RESPONSE_DELETE_SOLICITOR_GROUP,
    CHANGE_SOLICITOR_GROUP_LIST_SETTINGS, RECEIVE_DELETE_SOLICITOR_GROUP, REQUEST_DELETE_SOLICITOR_GROUP,
    SOLICITOR_GROUP_PAGE_SHIFT
} from "./index";

export function changeSolicitorGroupListSettings(key, value) {
    return {
        type: CHANGE_SOLICITOR_GROUP_LIST_SETTINGS,
        payload: {
            key,
            value
        }
    }
}



//action that shifts the page value +-1
export function solicitorGroupPageShift(direction, totalPaginationBoxes){
    return {
        type: SOLICITOR_GROUP_PAGE_SHIFT,
        payload: {
            direction: direction,
            totalPaginationBoxes: totalPaginationBoxes
        }
    }
}


//function that requests delete selected solicitor group
export function requestDeleteSolicitorGroup(groupId) {
    return {
        type: REQUEST_DELETE_SOLICITOR_GROUP,
        payload: groupId
    }
}

//function that receives response from deleting solicitor group
export function receiveDeleteSolicitorGroup(response) {
    return {
        type: RECEIVE_DELETE_SOLICITOR_GROUP,
        payload: response
    }
}

//function that receives bad request response from deleting a solicitor grouo
export function badResponseDeleteSolicitorGroup(response) {
    return {
        type: BAD_RESPONSE_DELETE_SOLICITOR_GROUP,
        payload:response
    }
}